{
  "es": {
    "qualityLabel": "Calidad",
    "presentLabel": "¿Hay en el piso?",
    "providerLabel": "¿Quién lo pone?",
    "requiredBadge": "Obligatorio",
    "photos": "Fotos",
    "addPhotos": "Agregar fotos",
    "noPhotos": "Sin fotos",
    "remove": "Quitar",
    "clearAll": "Limpiar fotos",
    "attachedFiles": "Archivos adjuntos",
    "tapToExpand": "Tocar para ampliar",
    "itemPlaceholder": "Elegir o escribir…",
    "notesPlaceholder": "Observaciones…",
    "presentOptions": {
      "UNSET": "—",
      "YES": "Sí",
      "NO": "No",
      "NOT_NEEDED": "No es necesario"
    },
    "providerOptions": {
      "UNSET": "—",
      "OWNER": "Propietario",
      "LIVE4LIFE": "Live4Life",
      "UNKNOWN": "No sé asignar"
    },
    "statusOptions": {
      "EXCELLENT": "Excelente",
      "GOOD": "Bueno",
      "REGULAR": "Regular",
      "BAD": "Malo",
      "MISSING": "Faltante",
      "NOT_EVALUATED": "—"
    }
  },
  "en": {
    "qualityLabel": "Condition",
    "presentLabel": "In the property?",
    "providerLabel": "Who provides it?",
    "requiredBadge": "Required",
    "photos": "Photos",
    "addPhotos": "Add photos",
    "noPhotos": "No photos",
    "remove": "Remove",
    "clearAll": "Clear photos",
    "attachedFiles": "Attached files",
    "tapToExpand": "Tap to enlarge",
    "itemPlaceholder": "Choose or type…",
    "notesPlaceholder": "Notes…",
    "presentOptions": {
      "UNSET": "—",
      "YES": "Yes",
      "NO": "No",
      "NOT_NEEDED": "Not necessary"
    },
    "providerOptions": {
      "UNSET": "—",
      "OWNER": "Owner",
      "LIVE4LIFE": "Live4Life",
      "UNKNOWN": "Don't know who to assign"
    },
    "statusOptions": {
      "EXCELLENT": "Excellent",
      "GOOD": "Good",
      "REGULAR": "Fair",
      "BAD": "Bad",
      "MISSING": "Missing",
      "NOT_EVALUATED": "—"
    }
  }
}
